import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";

export const usePatientPayments = ({
  page = 1,
  rows = 10,
  patientId,
  paymentDateFrom,
  paymentDateTo,
  paymentMethod,
  enabled = true,
  refetchOnWindowFocus = true
} = {}) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const currentPatientId = useCurrentPatientId();
  const finalPatientId = patientId || currentPatientId;

  return useQuery({
    queryKey: ["patientPayments", finalPatientId, tenantVal, page, rows, paymentDateFrom, paymentDateTo, paymentMethod],
    queryFn: async () => {
      if (!finalPatientId || !tenantVal) return null;
      const axiosInstance = await createAxiosInstance();
      
      const params = new URLSearchParams({
        page: page.toString(),
        rows: rows.toString()
      });

      if (paymentDateFrom) params.append('paymentDateFrom', paymentDateFrom);
      if (paymentDateTo) params.append('paymentDateTo', paymentDateTo);
      if (paymentMethod) params.append('paymentMethod', paymentMethod);

      const response = await axiosInstance.get(
        `${tenantVal}/consultationpayment/getbypatientid/${finalPatientId}/paginated?${params.toString()}`
      );
      return response.data;
    },
    enabled: enabled && !!finalPatientId && !!tenantVal,
    refetchOnWindowFocus,
    meta: { errorMessage: "Error fetching patient payments data" },
  });
};
